export default "__VITE_ASSET__CdLj6dej__"